import ClipLoader from "react-spinners/ClipLoader";

function Loader({ loading, progress, message }) {
  return (
    <div className="loading-container">
      <ClipLoader color={"#123abc"} loading={loading} size={150} />

      {/* Show progress and message if provided, otherwise show default */}
      {progress !== undefined && progress !== null ? (
        <div
          style={{
            marginTop: "20px",
            textAlign: "center",
            fontSize: "16px",
            color: "#333",
          }}
        >
          <div
            style={{
              fontWeight: "bold",
              fontSize: "24px",
              marginBottom: "10px",
            }}
          >
            {progress}%
          </div>
          <div style={{ color: "#666" }}>{message || "Processing..."}</div>
        </div>
      ) : (
        <p>Loading project data...</p>
      )}
    </div>
  );
}

export default Loader;
